var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoEyeCrossed = function SvgIcoEyeCrossed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M18.76 5.65a1 1 0 0 0-1.52-1.3l-12 14a1 1 0 0 0 1.52 1.3zM12 6q.579 0 1.14.06l-1.696 1.978A4 4 0 0 0 8 12.056l-3.073 3.586C3.12 14.356 2 12.857 2 12c0-1.714 4.477-6 10-6m4 6a4 4 0 0 1-3.444 3.962L10.86 17.94q.562.06 1.14.06c5.523 0 10-4.286 10-6 0-.857-1.119-2.356-2.927-3.642L16 11.944z",
    clipRule: "evenodd",
    opacity: 0.5
  })));
};
export default SvgIcoEyeCrossed;